import { render } from "./RegistroClienteGas.vue?vue&type=template&id=621b66c6&scoped=true"
import script from "./RegistroClienteGas.vue?vue&type=script&lang=js"
export * from "./RegistroClienteGas.vue?vue&type=script&lang=js"

import "./RegistroClienteGas.vue?vue&type=style&index=0&id=621b66c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621b66c6"]])

export default __exports__